import moment from 'moment-timezone';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';

export const UpdateNextAvailableDateModal = ({
  showModal,
  nextAvailableDate,
  setNextAvailableDate,
  nextAvailableError,
  setNextAvailableError,
  disabled,
  updateNextAvailableDate,
  setShowModal,
}) => {
  return (
    <>
      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header
        title="Next Available Date"
          closeButton
          onClick={() => {
            setNextAvailableError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Property Next Available Date</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2 mt-2">
            Next Available Date:
          </label>
          <ReactDatePicker 
            selected={nextAvailableDate} 
            onChange={(date) => setNextAvailableDate(date)}
            dateFormat="dd/MM/yyyy"
            minDate={moment().toDate()}
            placeholderText="Date"
            customInput={
            <input
              autoComplete="off"
              className={`form-control d-block w-100 mb-2`}
              type="text"
              />} 
            />
          {nextAvailableError && (
            <small className="text-danger">{nextAvailableError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={
              nextAvailableDate !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) => updateNextAvailableDate(event)}
            disabled={nextAvailableDate !== null && disabled === true}
          >
            {nextAvailableDate !== null && disabled === true
              ? 'Saving...'
              : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
